import React from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { Newspaper, ArrowLeft } from "lucide-react";
import { Path } from "../../../../../static/Constants";
import { NoData, CommonButton } from "../../../../Components/ui";

const NewsDetailsEmptyState = ({ errorMessage }) => {
  const history = useHistory();

  return (
    <NoData
      title="Article Not Found"
      description={
        errorMessage ||
        "The requested news article or announcement does not exist or may have been moved. Please browse our latest ecosystem stories."
      }
      icon={<Newspaper size={36} />}
      action={
        <CommonButton
          variant="primary"
          size="medium"
          startIcon={<ArrowLeft size={16} />}
          onClick={() => history.push(Path.news)}
        >
          Back to All News
        </CommonButton>
      }
      minHeight={360}
    />
  );
};

NewsDetailsEmptyState.propTypes = {
  errorMessage: PropTypes.string,
};

export default NewsDetailsEmptyState;
